import { isAfter } from 'date-fns';
import { useChallengeData } from '../../../../../../../../contexts/storage-contexts/Challenge';
import { useSections } from '../../../../../../../../contexts/ParticipantSections/ParticipantSectionsContext';
import { useParticipantSteps } from '../../../../../../../../contexts/ParticipantStepsDataProvider/ParticipantStepsContext';
import utils, {
  getFlatStepsList,
  isStepPending,
  isSectionLockedForStep,
} from '../../../../utils';
import { useSidebarLayoutBase } from '../../../contexts/SidebarLayoutBase/SidebarLayoutBaseContext';
import { getRightDateFromBackend } from '../../../../../../../../selectors/dates';

export function useStepIsUnavailable() {
  const {
    challengeData: { challenge },
  } = useChallengeData();
  const { currentStep } = useSidebarLayoutBase();
  const { listParticipantSections } = useSections();
  const { participantSteps } = useParticipantSteps();
  const flatSteps = getFlatStepsList({
    listParticipantSections,
    participantSteps,
  });

  const { isSectionLocked } = isSectionLockedForStep(
    currentStep,
    listParticipantSections,
  );

  const isLockedButVisible = utils.isVisibleStepLockedForComplete(
    challenge,
    flatSteps,
    currentStep,
  );

  const isStepHidden = utils.isStepHidden(challenge, flatSteps, currentStep);

  const isFutureScheduledStep =
    !isStepHidden &&
    !isLockedButVisible &&
    isStepPending(currentStep) &&
    isAfter(getRightDateFromBackend(currentStep?.dateFrame?.start), new Date());

  return {
    isStepUnavailable: isStepHidden || isLockedButVisible,
    isLockedButVisible,
    isFutureScheduledStep,
    firstAvailableStep: utils.getFirstAvailableStep(flatSteps),
    isSectionLocked,
  };
}
